// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"x5-z","dimensionLabel":"y5-z","styleChooserControlWrapper":"z5-z","styleChooserControl":"A5-z","disabled":"B5-z","giftCard":"C5-z","styleChooserText":"D5-z"};